import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { createSelector } from "reselect"
import { layoutTypes } from "./constants/layout"
// Import Routes all

// Import all middleware

// layouts Format
import VerticalLayout from "./components/VerticalLayout/"
import HorizontalLayout from "./components/HorizontalLayout/"
// import mainLoader from "./assets/icons/loader/main-loader.gif"
// Import scss
import "./assets/scss/theme.scss"

//toaster
import { ToastContainer } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
// Import Firebase Configuration file
// import { initFirebaseBackend } from "./helpers/firebase_helper";
// import Skeleton from 'react-loading-skeleton';
// import 'react-loading-skeleton/dist/skeleton.css';

import fakeBackend from "./helpers/AuthType/fakeBackend"
// import {
//   getSessionExpiryTime,
//   getTimeRemaining,
//   handleSessionExpiration,
//   scheduleSessionWarning,
// } from "helpers/session/sessionHelpers"
// import SessionWarningModal from "helpers/session/SessionWarningModal"
import DomainPage from "pages/Authentication/DomainPage"
import Footer from "components/VerticalLayout/Footer"
import mainLoader from "./assets/icons/loader/ezgif-7-9c8c6836e6.gif";

// import { Spinner } from "reactstrap"
// import Loading from "components/VerticalLayout/Loading"
// import { useDispatch } from "react-redux"

// Activating fake backend
fakeBackend()

// const firebaseConfig = {
//   apiKey: process.env.REACT_APP_APIKEY,
//   authDomain: process.env.REACT_APP_AUTHDOMAIN,
//   databaseURL: process.env.REACT_APP_DATABASEURL,
//   projectId: process.env.REACT_APP_PROJECTID,
//   storageBucket: process.env.REACT_APP_STORAGEBUCKET,
//   messagingSenderId: process.env.REACT_APP_MESSAGINGSENDERID,
//   appId: process.env.REACT_APP_APPID,
//   measurementId: process.env.REACT_APP_MEASUREMENTID,
// };

// init firebase backend
// initFirebaseBackend(firebaseConfig);

const getLayout = layoutType => {
  let Layout = VerticalLayout
  switch (layoutType) {
    case layoutTypes.VERTICAL:
      Layout = VerticalLayout
      break
    case layoutTypes.HORIZONTAL:
      Layout = HorizontalLayout
      break
    default:
      break
  }
  return Layout
}

const App = () => {
  // const dispatch = useDispatch()
  const selectLayoutState = state => state.Layout
  const LayoutProperties = createSelector(selectLayoutState, layout => ({
    layoutType: layout.layoutType,
  }))

  const { layoutType } = useSelector(LayoutProperties)

  const Layout = getLayout(layoutType)

  const [isLoading, setIsLoading] = useState(true)
  useEffect(() => {
    const delay = setTimeout(() => {
      setIsLoading(false)
    }, 1800)
    return () => clearTimeout(delay)
  }, [])

  // const [isModalOpen, setIsModalOpen] = useState(false)

  // const [authUser, setAuthUser] = useState(localStorage.getItem("authUser"))

  // useEffect(() => {
  //   if (!authUser) return // No authUser available

  //   let token
  //   try {
  //     const parsedAuthUser = JSON.parse(authUser)
  //     token = parsedAuthUser.access_token
  //   } catch (e) {
  //     console.error("Error parsing authUser:", e)
  //     return
  //   }

  //   if (!token) return // No token available

  //   const sessionExpiryTime = getSessionExpiryTime(token)

  //   if (!sessionExpiryTime) return

  //   const timeRemaining = getTimeRemaining(sessionExpiryTime)

  //   scheduleSessionWarning(sessionExpiryTime, () => {
  //     setIsModalOpen(true)
  //     // setIsModalOpen(false)
  //   })
  // }, [authUser]) // Dependency on authUser
  // useEffect(() => {
  //   const authUser = localStorage.getItem("authUser")
  //   if (!authUser) return

  //   const { token } = JSON.parse(authUser)
  //   if (!token) return

  //   const sessionExpiryTime = getSessionExpiryTime(token)
  //   if (!sessionExpiryTime) return

  //   scheduleSessionWarning(
  //     sessionExpiryTime,
  //     () => setIsModalOpen(true), // Warning callback: Show modal or warning message
  //     () => {
  //       // Expiration callback: Redirect to login or other actions
  //       window.location.href = "/login" // Redirect to login page
  //     }
  //   )
  // }, [])

  // useEffect(() => {
  //   const sessionExpired = localStorage.getItem("sessionExpired")

  //   if (sessionExpired === "true") {
  //     localStorage.setItem("sessionExpired", "false") // Reset flag to prevent continuous redirects
  //     toast.error("Session expired, Please login again", {
  //       position: "top-right",
  //       id: "Sidebar Session Expire message",
  //       autoClose: 3000,
  //     })
  //     window.location.href = "/login" // Redirect to login immediately
  //     return
  //   }

  //   const authUser = localStorage.getItem("authUser") // Retrieve authUser from localStorage

  //   if (!authUser) return // No authUser available

  //   let token
  //   try {
  //     const parsedAuthUser = JSON.parse(authUser)
  //     token = parsedAuthUser.access_token // Assuming your token is called access_token
  //   } catch (e) {
  //     console.error("Error parsing authUser:", e)
  //     return
  //   }

  //   if (!token) return // No token available

  //   const sessionExpiryTime = getSessionExpiryTime(token)
  //   if (!sessionExpiryTime) return

  //   const now = Date.now()
  //   const timeRemaining = sessionExpiryTime - now

  //   if (timeRemaining <= 0) {
  //     // If the session has already expired, handle it immediately
  //     handleSessionExpiration(() => {
  //       toast.error("Session timeout, please log in again", {
  //         position: toast.POSITION.TOP_RIGHT,
  //         autoClose: 3000,
  //       })
  //       window.location.href = "/login" // Redirect to the login page
  //     })
  //   } else {
  //     // Schedule a session warning 5 minutes before expiration
  //     scheduleSessionWarning(
  //       sessionExpiryTime,
  //       () => {
  //         setIsModalOpen(true) // Example action: open a modal
  //       },
  //       () => {
  //         handleSessionExpiration(() => {
  //           toast.error("Session timeout, please log in again", {
  //             position: toast.POSITION.TOP_RIGHT,
  //             autoClose: 3000,
  //           })
  //           window.location.href = "/login" // Redirect to the login page
  //         })
  //       }
  //     )
  //   }

  //   // Add global click event listener
  //   const handleClick = () => {
  //     const sessionExpired = localStorage.getItem("sessionExpired") === "true"
  //     if (sessionExpired) {
  //       handleSessionExpiration(() => {
  //         toast.error("Session timeout, please log in again", {
  //           position: toast.POSITION.TOP_RIGHT,
  //           autoClose: 3000,
  //         })
  //         window.location.href = "/login" // Redirect to the login page
  //       })
  //     }
  //   }

  //   document.addEventListener("click", handleClick)

  //   // Clean up event listener on component unmount
  //   return () => {
  //     document.removeEventListener("click", handleClick)
  //   }
  // }, [])

  document.title = "Testops"
  // const loading = useSelector(state => state.Loading.isLoading)

  return (
    <React.Fragment>
      {isLoading ? (
        <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "100vh",background:'#ffffffc2'}}
      >
           <img src={mainLoader} alt="Loading . . ." style={{height:'12rem'}}/>
        </div>
      ) : (
        <>
          <ToastContainer />
          <DomainPage />
          <Footer />
        </>
      )}
    </React.Fragment>
  )
}

App.propTypes = {
  layout: PropTypes.any,
}

export default App
